import React from 'react';

import { StyledList } from './BlockListStyles';

/**
 * Render unordered or ordered list in rich text
 *
 * @param {React.ReactNode} children
 * @param {'ul' | 'ol'} component
 *
 * @returns {React.ReactElement}
 */
function BlockList({ children, component }) {
  return <StyledList component={component}>{children}</StyledList>;
}

export default BlockList;
